// extracted by mini-css-extract-plugin
export default {"inputWrap":"Input_inputWrap__9hSqv","number":"Input_number__a20dd","input":"Input_input__aTcEV"};